import ReactGA from 'react-ga';

declare const heap: any;

export const HEAP_EVENTS: any = {
  subscriptionSuccess: 'Subscription',
};

export const identify = (id: string) => {
  heap.identify(id);
};

export const trackEvent = (event: string, params: any) => {
  heap.track(event, params);

  ReactGA.event({
    category: event,
    action: event,
  });
};



// WEBPACK FOOTER //
// ./src/utils/Analytics.ts